export default "__VITE_ASSET__69e5d8ca__"